import React from 'react'
import { Col, Collapse, Row, Icon } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Scrollbars } from 'react-custom-scrollbars';
import styled from "styled-components";
import styles from "./Modal.module.scss";
// Components
import Container from "../../../../containers/Container";
import Organization from '../../../../components/License/Organization'
import LicenseResult from '../../../../components/License/LicenseResult'
import ThongTinCT_XT from '../../../../components/License/ThongTinCT_XT'
import Licenses from '../../../../components/CongTrinh/GiayPhep/View'
import helper from '../../../../helper/helper'
import typo from '../../../../constants/dictionaries'
import TTKT from "../../../../components/AttachTable/TTKT/Table";
import DiemXaThais from "../../../../components/CongTrinh/DiemXaThai/View";
import TSQT from "../../../../components/AttachTable/TSQT/Table";
import FileDinhKemView from "../../../../components/CongTrinh/FileDinhKem/View";
import Constant from '../../../../constants/constant';
import Button from "../../../../components/Buttons"
const { Panel } = Collapse;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
class DischargeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {}
    }
  }

  componentDidMount() {
    const { data } = this.props
    this.setState({
      data: data
    })
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    const { data } = this.props
    if (prevProps.data !== data) {
      this.setState({
        data: data
      })
    }
  }

  render() {
    const {handleCloseModal} = this.props
    const { data } = this.state;
    const { ctxT_CongTrinh, hoSoXinCapPheps, ctxT_DiemXaThais, giayPhepHis, chatLuongNuocThai_JSON, thanhTra_KiemTras, thanhTras } = data;
    const chatLuongNuocThais = chatLuongNuocThai_JSON ? JSON.parse(chatLuongNuocThai_JSON) : [];
    const ttkts = thanhTra_KiemTras ? JSON.parse(thanhTra_KiemTras) : [];

    return (
      <Scrollbars ref="scrollbars" style={{ height: window.innerHeight * 0.8 }} autoHeightMax={window.innerHeight} autoHide autoHideTimeout={1000} autoHideDuration={200}>
        <Container style={{ padding: 20 }}>
          {data.soGiayPhep &&
            <Row type="flex">
              <Col span={12} style={{ paddingRight: 10 }}>
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_license_organization, 1)}</a>} key="1">
                    <Organization data={data} />
                  </Panel>
                </Collapse>
              </Col>
              <Col span={12} style={{ paddingLeft: 10 }}>
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_lichsu, 2)}</a>} key="1">
                    <Licenses dataSource={giayPhepHis} />
                  </Panel>
                </Collapse>
              </Col>
            </Row>}
          <div className="mt-20" />
          <Row type="flex">
            <Col span={12} style={{ paddingRight: 10 }}>
              <Collapse bordered={false} defaultActiveKey={['1']}>
                <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_ct_info, data.soGiayPhep ? 3 : 1)}</a>} key="1">
                  <ThongTinCT_XT
                    congTrinh={ctxT_CongTrinh}
                    banDo={data.soGiayPhep ? "Đã được cấp phép" : "Chưa được cấp phép"}
                  />
                </Panel>
              </Collapse>
            </Col>
            {data.soGiayPhep &&
              <Col span={12} style={{ paddingLeft: 10 }}>
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<a>{helper.generateIndexForLabel(typo.cscore_ketQuaGP, 4)}</a>} key="1">
                    <LicenseResult data={data} />
                  </Panel>
                </Collapse>
              </Col>}
          </Row >
          <div className="mt-20" />
          <Row type="flex">
            <Col span={12} style={{ paddingRight: 10 }}>
              <a>{helper.generateIndexForLabel(typo.cscore_diemXaThai, 3.1)} </a>
              <DiemXaThais dataSource={ctxT_DiemXaThais || []} />
            </Col>
            {data.soGiayPhep &&
              <Col span={12} style={{ paddingLeft: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_chatLuongNuocThai, 4.1)} </a>
                <TSQT mode="presentation" dataSource={chatLuongNuocThais || []} />
              </Col>
            }
          </Row>
          <div className="mt-20" />
          {data.soGiayPhep &&
            <Row type="flex">
                <Col span={12} style={{ paddingRight: 10 }}>
                  <a>{helper.generateIndexForLabel(typo.cscore_ttkt, 4.2)} </a>
                  <TTKT mode="presentation" dataSource={ttkts || []} />
                </Col>

              <Col span={12} style={{ paddingLeft: 10 }}>
                <a>{helper.generateIndexForLabel(typo.cscore_fileDinhkem, 4.4)} </a>
                <FileDinhKemView mode="presentation" dataSource={hoSoXinCapPheps || []} />
              </Col>
            </Row>}
            <ControllerButton>
            <Button
              type="cancel"
              className={styles.buttonMargin}
              onClick={handleCloseModal}
            >
              <Icon type="arrow-right" />
              {typo.cscore_exit}
            </Button>
          </ControllerButton>
        </Container>
      </Scrollbars>
    )
  }
}

DischargeDetail.propTypes = {
  idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(DischargeDetail)